<template>
  <v-col cols="12">
    <div>
      <naj-box
        :no-header="hideNajBox"
        :no-gutters="hideNajBox"
        :no-margin-bottom="hideNajBox"
        :title="locales.sectionTitle"
      >
        <v-row>
          <v-col cols="3">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.contractNumber"
              :value.sync="formModel.contractNumber"
              :disabled="isChecking || viewMode"
              validates="required|numeric"
              @input="contractNumberChanged"
            ></naj-input>
          </v-col>

          <v-col cols="3">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.partySocialId"
              :value.sync="formModel.partySocialId"
              :disabled="isChecking || viewMode"
              validates="required|digits:10"
              @input="partySocialIdChanged"
            ></naj-input>
          </v-col>

          <v-col cols="3">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.versionNumber"
              :value.sync="formModel.versionNumber"
              :disabled="isChecking || viewMode"
              validates="required|numeric"
              @input="versionNumberChanged"
            ></naj-input>
          </v-col>

          <v-col
            cols="3"
            align-self="center"
            class="text-right"
          >
            <naj-button
              v-if="isCheckButtonVisible"
              square
              :loading="isChecking"
              :disabled="isCheckButtonDisabled"
              @click="check"
            >
              {{ local.personInformation.check }}
            </naj-button>
          </v-col>
        </v-row>
      </naj-box>
    </div>

    <div>
      <naj-dynamic-form
        :form-model="formModel"
        :form-fields="form.fields"
        :view-mode="viewMode"
      ></naj-dynamic-form>
    </div>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'RealEstateContractDetails',
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    rootFormModel: {
      type: Object,
      required: true,
    },
    hideNajBox: {
      type: Boolean,
      required: false,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isRetrieved: false,
      isChecking: false,
      isManual: false,
      form: {
        'id': 154314,
        'name': 'RealEstateContractDetails',
        'label': 'بيانات العقد المبرم بين الطرفين',
        'description': 'بيانات العقد المبرم بين الطرفين',
        'isCustom': false,
        'customComponentName': null,
        'fields': [
          {
            'id': 154331,
            'typeId': 2,
            'name': 'contructNumber',
            'label': 'رقم العقد',
            'columnSize': 3,
            'sortIndex': 1,
            'properties': '{"validations":{"required":"true"},"dataSource":null,"dataGridConfig":null}',
            'description': 'رقم العقد',
            'fields': [],
          },
          {
            'id': 154332,
            'typeId': 3,
            'name': 'contructDate',
            'label': 'تاريخه',
            'columnSize': 3,
            'sortIndex': 2,
            'properties': '{"validations":{"required":"true"},"dataSource":null,"dataGridConfig":null, "dateConfig":{"acceptFutureDate":"true"}}',
            'description': 'تاريخه',
            'fields': [],
          },
          {
            'id': 154334,
            'typeId': 1,
            'name': 'lessorName',
            'label': 'اسم المؤجر',
            'columnSize': 3,
            'sortIndex': 3,
            'properties': '{"dataSource":null,"dataGridConfig":null}',
            'description': 'اسم المؤجر',
            'fields': [],
          },
          {
            'id': 154344,
            'typeId': 1,
            'name': 'renterName',
            'label': 'اسم المستأجر',
            'columnSize': 3,
            'sortIndex': 4,
            'properties': '{"dataSource":null,"dataGridConfig":null}',
            'description': 'اسم المستأجر',
            'fields': [],
          },
          {
            'id': 154335,
            'typeId': 2,
            'name': 'specifyContructDuration',
            'label': 'مدة العقد',
            'columnSize': 3,
            'sortIndex': 5,
            'properties': '{"validations":{"required":"true"},"externalDataSource":{},"textName":"rentContructDurationName","pickListId":45,"disabledIf":"","dataSource":null,"dataGridConfig":null}',
            'description': 'مدة عقد الإجارة',
            'fields': [],
          },
          {
            'id': 154336,
            'typeId': 4,
            'name': 'contructDurationUnit',
            'label': 'وحدة',
            'columnSize': 3,
            'sortIndex': 6,
            'properties': '{"validations":{"required":"true"},"if":"","externalDataSource":{},"textName":"contructDurationUnitName","pickListId":50,"disabledIf":"","internalDataSource":{},"dataSource":[{"key":1,"value":"يوم","id":1,"name":"يوم","statusId":1},{"key":2,"value":"شهر هجري","id":2,"name":"شهر هجري","statusId":1},{"key":3,"value":"شهر ميلادي","id":3,"name":"شهر ميلادي","statusId":1},{"key":4,"value":"سنة هجرية","id":4,"name":"سنة هجرية","statusId":1},{"key":5,"value":"سنة ميلادية","id":5,"name":"سنة ميلادية","statusId":1}],"dataGridConfig":null}',
            'description': 'وحدة',
            'fields': [],
          },
          {
            'id': 154337,
            'typeId': 4,
            'name': 'renew',
            'label': 'يتجدد تلقائياً',
            'columnSize': 3,
            'sortIndex': 7,
            'properties': '{"validations":{"required":"true"},"if":"","disabledIf":"","externalDataSource":{},"textName":"renewName","pickListId":1,"internalDataSource":{},"dataSource":[{"key":1,"value":"نعم","id":1,"name":"نعم","statusId":1},{"key":2,"value":"لا","id":2,"name":"لا","statusId":1}],"dataGridConfig":null}',
            'description': 'يتجدد تلقائياً',
            'fields': [],
          },
          {
            'id': 154338,
            'typeId': 3,
            'name': 'rentContractStartDate',
            'label': 'بداية مدة العقد',
            'columnSize': 3,
            'sortIndex': 8,
            'properties': '{"validations":{"required":"true"},"dataSource":null,"dataGridConfig":null, "dateConfig":{"acceptFutureDate":"true"}}',
            'description': 'بداية مدة العقد',
            'fields': [],
          },
          {
            'id': 154339,
            'typeId': 2,
            'name': 'yearlyRentCost',
            'label': 'مقدار الأجرة',
            'columnSize': 3,
            'sortIndex': 9,
            'properties': '{"validations":{"required":"true"},"showDescriptionTooltip":true,"dataSource":null,"dataGridConfig":null}',
            'description': 'مقدار الأجرة (اليومية/الشهرية/السنوية)',
            'fields': [],
          },
          {
            'id': 154340,
            'typeId': 4,
            'name': 'paymentMethod',
            'label': 'طريقة السداد',
            'columnSize': 3,
            'sortIndex': 10,
            'properties': '{"validations":{"required":"true"},"externalDataSource":{},"textName":"paymentMethodName","pickListId":46,"internalDataSource":{},"dataSource":[{"key":1,"value":"دفعة واحدة","id":1,"name":"دفعة واحدة","statusId":1},{"key":2,"value":"دفعات","id":2,"name":"دفعات","statusId":1}],"dataGridConfig":null}',
            'description': 'طريقة السداد',
            'fields': [],
          },
          {
            'id': 154341,
            'typeId': 4,
            'name': 'regularMagnitude',
            'label': 'منتظمة المقدار',
            'columnSize': 3,
            'sortIndex': 11,
            'properties': '{"validations":{"required":"true"},"externalDataSource":{},"textName":"regularMagnitudeName","pickListId":324,"showDescriptionTooltip":true,"internalDataSource":{},"dataSource":[{"key":1,"value":"منتظمة","id":1,"name":"منتظمة","statusId":1},{"key":2,"value":"غير منتظمة","id":2,"name":"غير منتظمة","statusId":1}],"dataGridConfig":null}',
            'description': 'متساوية القدر',
            'fields': [],
          },
          {
            'id': 154342,
            'typeId': 2,
            'name': 'paidPayments',
            'label': 'المبالغ المسلمة من بداية العقد',
            'columnSize': 3,
            'sortIndex': 12,
            'properties': '{"validations":{"required":"true"},"dataSource":null,"dataGridConfig":null}',
            'description': 'المبالغ المسلمة من بداية العقد',
            'fields': [],
          },
          {
            'id': 154343,
            'typeId': 2,
            'name': 'remainingFareWithLessor',
            'label': 'المبالغ الحالة غير المسلمة',
            'columnSize': 3,
            'sortIndex': 13,
            'properties': '{"validations":{"required":"true"},"dataSource":null,"dataGridConfig":null}',
            'description': 'المبالغ الحالة غير المسلمة',
            'fields': [],
          },
          {
            'id': 154345,
            'typeId': 3,
            'name': 'claimPeriodDateTo',
            'label': 'نهاية فترة المطالبة',
            'columnSize': 3,
            'sortIndex': 14,
            'properties': '{"validations":{"required":"true"},"showDescriptionTooltip":true,"dataSource":null,"dataGridConfig":null, "dateConfig":{"acceptFutureDate":"true"}}',
            'description': 'آخر يوم من المدة محل الاستحقاق',
            'fields': [],
          },
        ],
      },
    };
  },
  computed: {
    locales() {
      return this.local.dynamicFormAdmin.customComponents.RealEstateContractDetails;
    },
    isCheckButtonDisabled() {
      return (
        !this.formModel.contractNumber ||
        !this.formModel.partySocialId ||
        !this.formModel.versionNumber ||
        this.isChecking
      );
    },
    isCheckButtonVisible() {
      return !this.isRetrieved || this.isChecking;
    },
    isFieldDisabled() {
      return this.isManual || this.isChecking;
    },
  },
  mounted() {
    if (this.formModel.objectKey) {
      this.isRetrieved = true;
    }
  },
  methods: {
    ...mapGlobalActions(['getRealEstateContractDetails']),
    check() {
      this.isChecking = true;
      this.resetFlags();

      this.getRealEstateContractDetails({
        contractNumber: this.formModel.contractNumber,
        partySocialId: this.formModel.partySocialId,
        versionNumber: this.formModel.versionNumber,
      })
        .then((res) => {
          if (res.data) {
            this.isRetrieved = true;
            const contractDetailsResult = res.data;

            const mappedData = {
              objectKey: contractDetailsResult.contractNumber,
              contructNumber: contractDetailsResult.contractNumber,
              contructDate: contractDetailsResult.contractDate,
              lessorName: contractDetailsResult.lessorFullName,
              renterName: contractDetailsResult.tenantFullName,
              specifyContructDuration: contractDetailsResult.contractDuration,
              contructDurationUnit: '',
              renew: '',
              rentContractStartDate: contractDetailsResult.contractStartDate,
              yearlyRentCost: contractDetailsResult.invoiceAmount,
              paymentMethod: '',
              regularMagnitude: '',
              paidPayments: '',
              remainingFareWithLessor: contractDetailsResult.invoiceRemainingAmount,
              claimPeriodDateTo: contractDetailsResult.invoiceDueDate,
            };
            Object.keys(mappedData)
              .map((key) => {
                this.$set(this.formModel, key, mappedData[key]);
                return key;
              });
          }
        })
        .catch(() => {
          this.isManual = true;
          this.toaster.error(this.local.common.noData);
          this.clearFormData();
        })
        .finally(() => {
          this.isChecking = false;
        });
    },
    resetFlags() {
      this.isRetrieved = false;
      this.isManual = false;
    },
    partySocialIdChanged() {
      this.resetFlags();
      this.clearFormData();
    },
    versionNumberChanged() {
      this.resetFlags();
      this.clearFormData();
    },
    contractNumberChanged() {
      this.resetFlags();
      this.clearFormData();
    },
    clearFormData() {
      const mappedData = {
        objectKey: null,
        contructNumber: null,
        contructDate: null,
        lessorName: null,
        renterName: null,
        specifyContructDuration: null,
        contructDurationUnit: null,
        renew: null,
        rentContractStartDate: null,
        yearlyRentCost: null,
        paymentMethod: null,
        regularMagnitude: null,
        paidPayments: null,
        remainingFareWithLessor: null,
        claimPeriodDateTo: null,
      };
      Object.keys(mappedData)
        .map((key) => {
          this.$set(this.formModel, key, mappedData[key]);
          return key;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>